import { QueryKey } from '@tanstack/react-query'
import dayjs from '@mobi/utils/date/extendedDayjs'
import type { PageDataTransferObject } from '@mobi/api-types'
import { get } from '@classic/Foundation/Services/ApiService'
import { queryKeys } from '@core/Data/ReactQuery/constants'

export const queryKey = (meetingId: string, meetingDate: Date, raceNumbers: number[]): QueryKey => {
  return [queryKeys.racePageStartersForRaces, meetingId.toLowerCase(), meetingDate, raceNumbers]
}

export const queryFn = async (
  meetingId: string,
  meetingDate: Date,
  raceNumbers: number[]
): Promise<PageDataTransferObject> => {
  const url = getRaceStartersApiUrl(meetingId, meetingDate, raceNumbers)
  return await get<PageDataTransferObject>({ url })
}

function getRaceStartersApiUrl(
  meetingId: string,
  meetingDate: Date,
  raceNumbers: number[]
): string {
  const formattedDate = dayjs(meetingDate).format('YYYY-MM-DD')
  return `/api/meetings/${meetingId}/${formattedDate}/races/${raceNumbers.join(',')}`
}
